// extracted by mini-css-extract-plugin
module.exports = {"borderr":"Detail_borderr__1Q2wk"};